import {
  deleteData,
  getData,
  patchData,
  postData,
  putData,
} from '../../../helpers/axiosHelper';
import { queryString } from '../../../utils/heap';

import { CUSTOMERS_ENDPOINT } from '../consts';
import {
  IGetCustomerFullNameResponseData,
  IGetCustomerLinkedAccountsResponseData,
  IGetCustomerProfileResponseData,
  IGetCustomerResponseData,
  IGetDemandDashboardResponseData,
  IGetOtherCustomerProfileResponseData,
  IGetSupplierDashboardResponseData,
  IUpdateCustomerProfileRequestData,
  IUpdateCustomerRequestData,
  IUpdateCustomerResponseData,
  IUploadAvatarResponse,
} from '../types';

export const getCustomer = async (
  customerId?: string
): Promise<IGetCustomerResponseData> => {
  const url = `${CUSTOMERS_ENDPOINT}/me`;
  return getData(
    queryString.stringifyUrl({
      url,
      query: {
        customerId,
      },
    })
  );
};

export const updateCustomer = async (
  data: IUpdateCustomerRequestData
): Promise<IUpdateCustomerResponseData> => {
  const url = `${CUSTOMERS_ENDPOINT}/me`;
  return putData(url, data);
};

// BE: interface on FE and swagger differs
export const getCustomerProfileDetails =
  async (): Promise<IGetCustomerProfileResponseData> => {
    const url = `${CUSTOMERS_ENDPOINT}/me/profile`;
    return getData(url);
  };

export const updateCustomerProfileDetails = async (
  data: IUpdateCustomerProfileRequestData
): Promise<void> => {
  const url = `${CUSTOMERS_ENDPOINT}/me/profile`;
  return patchData(url, data);
};

export const getOtherCustomerProfile = async (
  customerId: string
): Promise<IGetOtherCustomerProfileResponseData> => {
  const url = `${CUSTOMERS_ENDPOINT}/${customerId}/profile`;
  return getData(url);
};

export const getDemandDashboard =
  async (): Promise<IGetDemandDashboardResponseData> => {
    const url = `${CUSTOMERS_ENDPOINT}/demand/dashboard`;
    return getData(url);
  };

export const getSupplierDashboard =
  async (): Promise<IGetSupplierDashboardResponseData> => {
    const url = `${CUSTOMERS_ENDPOINT}/supplier/dashboard`;
    return getData(url);
  };

export const customerProfileDetailsUpdated = async (): Promise<void> => {
  const url = `${CUSTOMERS_ENDPOINT}/profile-updated`;
  return patchData(url);
};

export const getCustomerFullName = async (
  customerId: string
): Promise<IGetCustomerFullNameResponseData> => {
  const url = `${CUSTOMERS_ENDPOINT}/customerfullname`;
  return getData(url, { customerId });
};

export const getCustomerLinkedAccounts = async (
  customerId: string
): Promise<IGetCustomerLinkedAccountsResponseData> => {
  const url = `${CUSTOMERS_ENDPOINT}/customer-connections`;
  return getData(
    queryString.stringifyUrl({
      url,
      query: {
        customerId,
      },
    })
  );
};

export const uploadCustomerAvatar = async (
  formData: FormData
): Promise<IUploadAvatarResponse> => {
  const url = `${CUSTOMERS_ENDPOINT}/avatar`;
  return postData(url, formData, {
    'Content-Type': 'multipart/form-data',
  });
};

export const deleteCustomerAvatar = async (): Promise<void> => {
  const url = `${CUSTOMERS_ENDPOINT}/avatar`;
  return deleteData(url);
};
